import type { AppState } from 'types/app';

export const selectLandingPageName = (state: AppState) => state.landingPage.pageName;

export const selectLandingPageInfo = (state: AppState) => state.landingPage.pageInfo;
